import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { InventoryModalProps } from "../../data-models/props";
import { DataService } from "../../services/data-service";
import { useStoreActions, useStoreState } from "../../store/data-store";
import ColourSwatch from "../colour-swatch/colour-swatch";

const InventoryModal = ({closeModal, inventory}:InventoryModalProps) => {

    const [colourNumber, setColourNumber] = useState(inventory.colourNumber);
    const [meters, setMeters] = useState(inventory.meters);
    const [onBobbin, setBobbin] = useState(inventory.isOnBobbin);

    const newInventory = inventory.id === 0;

    const user = useStoreState(store => store.user);
    const addInventory = useStoreActions(store => store.addInventory);

    const saveInventory = () => {
        async function save() {
            const dataService = new DataService();
            const tokens = await dataService.getAccessToken(user);
            if(newInventory){
                inventory.colourNumber = colourNumber;
                inventory.meters = meters;
                inventory.isOnBobbin = onBobbin;
                var i = await dataService.addInventory(user.id, tokens.accessToken,inventory);
                addInventory(i);
                closeModal();
            }
            else {
                inventory.meters = meters;
                inventory.isOnBobbin = onBobbin;
                await dataService.updateInventory(user.id, tokens.accessToken, inventory);
                closeModal();
            }
        }
        save();
    }

    function subtractSkein() {
        var newInv = Math.max(0, meters-8);
        setMeters(newInv);
    }

    function addSkein() {
        setMeters(meters+8);
    }

    return (
        <div className='modal-container' >
            <div className='overlay' onClick={closeModal} />
            <div className='modal'>
                <div className="user-input-data">
                    <h2>Inventory<FontAwesomeIcon icon="trash" onClick={() => { }} title="Delete Account" /></h2>
                    <div>
                        <label className="field-label">Colour Number</label>
                        <input readOnly={!newInventory}  value={colourNumber} onChange={(e) => setColourNumber(e.currentTarget.value)} />
                    </div>
                    <div>
                        <label className="field-label">Meters</label>
                        <FontAwesomeIcon icon="minus" onClick={subtractSkein}></FontAwesomeIcon>
                        <input value={meters} className="meters-input" onChange={(e) => setMeters(Number(e.currentTarget.value))} />
                        <FontAwesomeIcon icon="plus" onClick={addSkein}></FontAwesomeIcon>
                    </div>
                    <div>
                        <label className="field-label">On Bobbin</label>
                        <input type="checkbox" checked={onBobbin} onChange={(e) => setBobbin(!onBobbin)} />
                    </div>
                    <div>
                        <label className="field-label">Colour</label>
                        <ColourSwatch colourNumber={colourNumber}/>
                    </div>
                </div>
                <div className="modal-actions">
                    <button className="small-button" onClick={closeModal} >Cancel</button>
                    <button className='procom-button small-button' onClick={saveInventory} >Save</button>
                </div>
            </div>
        </div>

    )
}

export default InventoryModal;